module.exports = __webpack_public_path__ + "static/media/info-tooltip-active.a952ecf1.svg";